export default {"src":"/images/12.jpg","width":681,"height":1000,"aspectRatio":0.681};